var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
export default React.memo(function (props) {
    return (React.createElement("svg", __assign({ width: 48, height: 48, viewBox: "0 0 48 48", xmlns: "http://www.w3.org/2000/svg" }, props),
        React.createElement("path", { d: "M13.542 29.603c.449.321.559.942.246 1.397a.975.975 0 01-1.37.242l-9.004-6.428a1 1 0 010-1.628l9.003-6.428a.975.975 0 011.371.242 1.012 1.012 0 01-.246 1.397L7.094 23h33.811l-6.447-4.603a1.012 1.012 0 01-.311-1.29l.065-.107a.975.975 0 011.37-.242l9.004 6.428a1 1 0 010 1.628l-9.003 6.428A.975.975 0 0134.212 31a1.012 1.012 0 01.246-1.397L40.905 25H7.094l6.448 4.603z", fill: "currentColor", fillRule: "nonzero", stroke: "none", strokeWidth: 1 })));
});
